export default function initVideoModal() {
    /**
     * ------------------------------------------------------
     * VIDEO MODAL
     * ------------------------------------------------------
     */
    const openButtons = document.querySelectorAll("[data-video-modal-open]");

    const modals = document.querySelectorAll("[data-video-modal]");

    if (!openButtons.length || !modals.length) {
        return;
    }

    /**
     * --------------------------------------------------
     * OPEN
     * --------------------------------------------------
     */

    openButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const videoUrl = button.dataset.videoUrl;

            if (!videoUrl) {
                return;
            }

            /**
             * On récupère la modal située après
             * le composant feature-media.
             */
            const section = button.closest(".feature-media");

            if (!section) {
                return;
            }

            const modal = section.nextElementSibling;

            if (!modal || !modal.matches("[data-video-modal]")) {
                return;
            }

            const iframe = modal.querySelector("[data-video-modal-frame]");

            if (!iframe) {
                return;
            }

            /**
             * Charge Vimeo uniquement à l'ouverture.
             */
            iframe.src = videoUrl;

            /**
             * Affiche la modal.
             */
            modal.classList.remove("hidden");
            modal.classList.add("flex");

            modal.setAttribute("aria-hidden", "false");

            /**
             * Bloque le scroll de la page.
             */
            document.body.classList.add("overflow-hidden");

            /**
             * Mémorise le bouton pour rendre
             * le focus à la fermeture.
             */
            modal._triggerButton = button;

            /**
             * Focus sur le bouton fermer.
             */
            const closeButton = modal.querySelector("[data-video-modal-close]");

            if (closeButton) {
                closeButton.focus();
            }
        });
    });

    /**
     * --------------------------------------------------
     * CLOSE
     * --------------------------------------------------
     */

    const closeModal = (modal) => {
        if (!modal) {
            return;
        }

        const iframe = modal.querySelector("[data-video-modal-frame]");

        modal.classList.add("hidden");
        modal.classList.remove("flex");

        modal.setAttribute("aria-hidden", "true");

        /**
         * Très important :
         * supprimer le src arrête Vimeo.
         */
        if (iframe) {
            iframe.src = "";
        }

        document.body.classList.remove("overflow-hidden");

        /**
         * Retour du focus sur le bouton.
         */
        if (modal._triggerButton) {
            modal._triggerButton.focus();
        }
    };

    /**
     * --------------------------------------------------
     * CLOSE BUTTONS + BACKDROP
     * --------------------------------------------------
     */

    modals.forEach((modal) => {
        const closeButtons = modal.querySelectorAll("[data-video-modal-close]");

        closeButtons.forEach((button) => {
            button.addEventListener("click", () => {
                closeModal(modal);
            });
        });
    });

    /**
     * --------------------------------------------------
     * ESCAPE
     * --------------------------------------------------
     */

    document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") {
            return;
        }

        const openedModal = document.querySelector('[data-video-modal][aria-hidden="false"]');

        if (openedModal) {
            closeModal(openedModal);
        }
    });
}
